import EVENTS from '@/api/events'
// import _ from 'lodash'
// import structure from '@/assets/structure.json'
const state = {
  headerTextColor: '#000000',
  headerBgColor: ''
}
// getters
const getters = {
  // structure: (state) => {
  //   return state.structure
  // }
  headerTextColor: state => {
    return state.headerTextColor
  },
  headerBgColor: state => {
    return state.headerBgColor
  }
}

// actions
const actions = {
  fetchEvent: function ({ commit, state, rootGetters }, eventId) {
    return EVENTS.getEvent(eventId, { currency: rootGetters['user/selectedCurrency'] }).then(res => {
      return res.data
    })
  },
  fetchWebEvent: function ({ commit, state, rootGetters }, eventId) {
    return EVENTS.getWebEvent(eventId, { currency: rootGetters['user/selectedCurrency'] }).then(res => {
      return res.data
    })
  }
}

// mutations
const mutations = {
  // SET_STRUCTURE: function (state, payload) {
  //   state.structure = payload
  // }
  SET_HEADERTEXTCOLOR: function (state, payload) {
    state.headerTextColor = payload
  },
  SET_HEADERBGCOLOR: function (state, payload) {
    state.headerBgColor = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
